// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleTaskSheet-module__backdrop___9jfHn {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.HuddleTaskSheet-module__backdropDismiss___k7TSw {
  position: absolute;
  inset: 0;
  border: none;
  padding: 0;
  background: rgba(24, 24, 27, 0.4);
  cursor: default;
}

.HuddleTaskSheet-module__panel___jXsIK {
  position: relative;
  width: 560px;
  max-width: 100%;
  height: 100%;
  background: #fafafa;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  padding: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleTaskSheet/HuddleTaskSheet.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,iCAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,aAAA;AACF","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.backdropDismiss {\n  position: absolute;\n  inset: 0;\n  border: none;\n  padding: 0;\n  background: rgba(24, 24, 27, 0.4);\n  cursor: default;\n}\n\n.panel {\n  position: relative;\n  width: 560px;\n  max-width: 100%;\n  height: 100%;\n  background: #fafafa;\n  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);\n  overflow-y: auto;\n  padding: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `HuddleTaskSheet-module__backdrop___9jfHn`,
	"backdropDismiss": `HuddleTaskSheet-module__backdropDismiss___k7TSw`,
	"panel": `HuddleTaskSheet-module__panel___jXsIK`
};
module.exports = ___CSS_LOADER_EXPORT___;
